<template lang="pug">
  .container
    .columns.has-text-left
      .column.is-12
        .notification
          strong.has-text-dark Totales ☣
          br
          span.has-text-dark Confirmados:&nbsp
          b.has-text-grey {{ dataGereral.confirmed | numFormat }}
          br
          span.has-text-dark Muertes:&nbsp
          b.has-text-danger {{ dataGereral.deaths | numFormat }}
          br
          span.has-text-dark Recuperados:&nbsp
          b.has-text-info {{ dataGereral.recovered | numFormat }}
</template>

<script>
export default {
  name: 'PanelData',
  props: {
    dataGereral: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="css" scoped>
  .column {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .notification {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
</style>
